<div class="tbody">
    <ul *ngFor="let row of loadingArr" >
        <li class="tr-placeholder">
            <div class="animated-background"></div>
        </li>
    </ul>
</div>
